
export class Palette {
    static background = "rgb(255, 255, 255)";
    static panelBackground = "rgb(249, 249, 249)";
    static accent = "rgb(32, 56, 194)";
}